import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ModalAsignacionInicialPage } from './modal-asignacion-inicial.page';

const routes: Routes = [
  {
    path: '',
    component: ModalAsignacionInicialPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalAsignacionInicialPageRoutingModule {}
